import { render, staticRenderFns } from "./DocumentFieldsManager.vue?vue&type=template&id=03fc37d4&"
import script from "./DocumentFieldsManager.vue?vue&type=script&lang=js&"
export * from "./DocumentFieldsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports